/* eslint-disable arrow-body-style */
import { Modal } from '@mui/material';
import { StyledModalBox } from '../styles';
import BlogNewEditForm from 'src/sections/@dashboard/blog/BlogNewEditForm';
import { Blog } from '../../../../@types/blog';

type BlogModalProps = {
  open: boolean;
  handleClose(): void;
  isEdit: boolean;
  currentBlog: Blog | undefined;
};

export const BlogModal = ({ open, handleClose, isEdit, currentBlog }: BlogModalProps) => {
  return (
    <Modal open={open} onClose={handleClose}>
      <StyledModalBox>
        <BlogNewEditForm handleClose={handleClose} isEdit={isEdit} currentBlog={currentBlog} />
      </StyledModalBox>
    </Modal>
  );
};
